export const pdfs = [
  {
    label: 'project.inventoryList',
    key: 'inventoryList',
  },
  {
    label: 'project.inventoryListShort',
    key: 'inventoryListShort',
  },
  {
    label: 'project.rightsDevisionPDF',
    key: 'rightsDevisionPDF',
  },
];

export const status = [
  {
    key: 'initialConsultation',
    label: 'status.initialConsultation',
  },
  {
    key: 'inventory',
    label: 'status.inventory',
  },
  {
    key: 'collectionAndImageProcessing',
    label: 'status.collectionAndImageProcessing',
  },
  {
    key: 'valuationAndThirdpartyRights',
    label: 'status.valuationAndThirdpartyRights',
  },
  {
    key: 'shipping',
    label: 'status.shipping',
  },
  {
    key: 'securing',
    label: 'status.securing',
  },
  {
    key: 'catalogueCreation',
    label: 'status.catalogueCreation',
  },
  {
    key: 'publishOnline',
    label: 'status.publishOnline',
  },
  {
    key: 'advertisement',
    label: 'status.advertisement',
  },
  {
    key: 'viewing',
    label: 'status.viewing',
  },
  {
    key: 'auctionEnd',
    label: 'status.auctionEnd',
  },
  {
    key: 'pickUp',
    label: 'status.pickUp',
  },
  {
    key: 'completed',
    label: 'status.completed',
  },
  {
    key: 'archived',
    label: 'status.archived',
  },
];

export const accounting_status = [
  {
    key: 'open',
    label: 'accountingStatus.open',
  },
  {
    key: 'interimInvoiceCreated',
    label: 'accountingStatus.interimInvoiceCreated',
  },
  {
    key: 'paymentOnAccount1Initiated',
    label: 'accountingStatus.paymentOnAccount1Initiated',
  },
  {
    key: 'paymentOnAccount2Initiated',
    label: 'accountingStatus.paymentOnAccount2Initiated',
  },
  {
    key: 'invoiceCreated',
    label: 'accountingStatus.invoiceCreated',
  },
  {
    key: 'finalAccountingAfterRealizationCreated',
    label: 'accountingStatus.finalAccountingAfterRealizationCreated',
  },
];

export const project_types = [
  {
    key: 'inventorization',
    label: 'project.type.inventorization',
  },
  {
    key: 'expertise',
    label: 'project.type.expertise',
  },
  {
    key: 'valuation',
    label: 'project.type.valuation',
  },
  {
    key: 'rating',
    label: 'project.type.rating',
  },
  {
    key: 'briefExpertReport',
    label: 'project.type.briefExpertReport',
  },
  {
    key: 'expertReport',
    label: 'project.type.expertReport',
  },
];
